/**
 * Generates a dropdown menu and appends it to a specified container.
 *
 * @param {string} container_id - The ID of the container element where the dropdown will be appended.
 * @param {Object} mapping - The mapping object containing keys and display texts for the dropdown items.
 */
export function gen_dropdown(container_id, mapping) {
    const container = document.getElementById(container_id);
    const dropdown_btn = document.createElement("button");
    dropdown_btn.className = "btn btn-outline-secondary dropdown-toggle rounded-5 btn-sm fw-semibold border-2";
    dropdown_btn.type = "button";
    dropdown_btn.id = `${container_id}_btn`
    dropdown_btn.setAttribute("data-bs-toggle", "dropdown");
    dropdown_btn.setAttribute("aria-expanded", false);
    dropdown_btn.textContent = mapping[Object.keys(mapping)[0]];

    const menu = document.createElement("ul");
    menu.className = "dropdown-menu";

    for (let key in mapping) {
        let item = document.createElement("li");
        let item_content = document.createElement("a");
        item_content.className = "dropdown-item fw-medium";
        item_content.href = "#";

        item_content.textContent = mapping[key];
        item.appendChild(item_content);

        // Append the <li> to the <ul> (menu)
        menu.appendChild(item);
    }

    container.appendChild(dropdown_btn);
    container.appendChild(menu);
}